import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useProfile, useSession } from './useSession';
import type { UserRole } from '@mudong/shared';

interface Props {
  role: UserRole | UserRole[];
  children: ReactNode;
}

export function RequireRole({ role, children }: Props) {
  const { session, loading } = useSession();
  const { data: profile, isLoading } = useProfile();
  const location = useLocation();

  // 1) 세션 미확인 단계는 무조건 대기 (절대 /login으로 튕기지 않는다)
  if (loading) {
    return <div className="text-center py-12 text-ink-muted">잠시만 기다려주세요…</div>;
  }
  // 2) 세션이 없으면 로그인 필요
  if (!session) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  // 3) 세션은 있는데 프로필 로딩 중이거나 데이터 미수신이면 대기
  //    (useProfile 의 enabled 토글 직후 한 틱 동안 isLoading=false + data=undefined 인 상태가 존재)
  if (isLoading || profile === undefined) {
    return <div className="text-center py-12 text-ink-muted">잠시만 기다려주세요…</div>;
  }
  // 4) 세션 + 프로필 조회 완료. profile이 null 이면 가입 직후 행이 없는 케이스(혹은 RLS) — 로그아웃.
  if (!profile) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  const allowed = Array.isArray(role) ? role.includes(profile.role) : profile.role === role;
  if (!allowed) {
    return <Navigate to={profile.role === 'admin' ? '/admin' : '/me'} replace />;
  }
  return <>{children}</>;
}
